import type { ForwardedRef } from 'react';

import { useImperativeHandle, useMemo } from 'react';

import type { ErrorBoundaryHooks, ErrorBoundaryProps, ErrorBoundaryRef } from './_.type';

/**
 * Use ErrorBoundary hooks.
 *
 * @param {ErrorBoundaryProps} _props ErrorBoundary props.
 * @param {ErrorBoundaryRef} ref ErrorBoundary ref.
 *
 * @returns {ErrorBoundaryHooks} ErrorBoundary hooks.
 */
export default function useErrorBoundaryHooks(_props: ErrorBoundaryProps, ref: ForwardedRef<ErrorBoundaryRef>): ErrorBoundaryHooks {
  useImperativeHandle(ref, () => ({}));

  return useMemo<ErrorBoundaryHooks>(
    () => ({
      refs: {},

      states: {},

      events: {},
    }),
    [],
  );
}
